<template>
    <v-container class="pa-0 pt-2 px-0">
        <v-row  class="pa-6" v-show="emptyChart">
        <p>Não foram encontrados dados para o período.</p>
        </v-row>
        <chart id="bar" :options="option" v-show="!emptyChart"/>
    </v-container>
</template>

<script>
import { mapActions } from "vuex"
import ECharts from "vue-echarts"
import echarts from "echarts"
import moment from "moment"
export default {
    components: {
        chart: ECharts,
    },
    data() {
        return {
            option: {},
            emptyChart: false
        }
    },
    props: {
        list: Object,
        listOperadora: Object,
        getGrafico: Function,
    },
    watch: {
        list(val) {
            this.chartsBar()
            this.emptyChart = !val.operadoras.length
        }
    },
    mounted() {
        this.chartsBar()
    },
    methods: {
        ...mapActions('autorizador', [
            "setFilter"
        ]),
        chartsBar() {
            let { operadoras, autorizadas, negadas, outros } = this.list
            this.emptyChart = operadoras ? !operadoras.length  : true
            let operadorasNome = operadoras ? operadoras.map(oper => this.listOperadora[oper]) : []
            let fontSize = operadorasNome.length >= 10 ? 8 : 12

            var myChart = echarts.init(document.getElementById('bar'));

            this.option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {           
                        type: 'none'       
                    }
                },
                grid: {
                    left: '2%',
                    right: '3%',
                    bottom: '6%',
                    top: '8%',
                    containLabel: true
                },
                title: {
                    subtext: 'Performance operadoras',
                    left: '1%',
                    top: '-5%'
                },
                xAxis: {
                    type: 'category',
                    data: operadorasNome,
                    axisLabel: {
                        textStyle: {
                            color: '##4A4A4A',
                            fontSize: fontSize,
                        },
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999'
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#4a4a4a1f",
                        },
                    },
                },
                series: [
                    {
                        name: 'Outros',
                        id: null,
                        type: 'bar',
                        color: '#D3DBDF',
                        stack: 'chart',
                        barWidth: '25%',
                        data: outros,
                        label: {
                            color: '#4A4A4A',
                            show: true,
                        },
                    },
                    {
                        name: 'Negadas',
                        id: 3,
                        type: 'bar',
                        color: '#D0021B',
                        stack: 'chart',
                        barWidth: '25%',
                        data: negadas,
                        label: {
                            color: '#4A4A4A',
                            show: true,
                        },
                    },
                    {
                        name: 'Autorizadas',
                        id: 1,
                        type: 'bar',
                        color: '#32B88B',
                        stack: 'chart',
                        barWidth: '25%',
                        data: autorizadas,
                        label: {
                            color: '#4A4A4A',
                            show: true,
                        },  
                    }
                ]
            };

            myChart.on('click', (params) => {
                let status = { seriesId: params.seriesId }
                let data_inicio = moment(this.list.data_referencia).startOf('month').format('YYYY-MM-DD')
                let data_final = moment(this.list.data_referencia).endOf('month').format('YYYY-MM-DD')
                let operadora_ans_id = this.list.operadoras[params.dataIndex]
                let periodo = "mes"
                this.setFilter({data_inicio, data_final, operadora_ans_id, periodo, status})
            });
        },
    },
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 300px;
}
.chart-date {
    font-family: sans-serif;
    font-size: 17px;
    color: black;
}
</style>